<template>
  <div
    class="annotation-footer uk-flex uk-flex-middle uk-margin-small-top uk-text-small uk-position-relative"
  >
    <SVGButton
      :icon="likeIcon"
      title="Like"
      :buttonSize="true"
      :disabled="reportView"
      :style="`border:none; background:none;`"
      :size="buttonSize"
      @click="onLike"
    >
      <span
        v-if="showCounts"
        :style="{ color: reportView ? 'black' : '' }"
        class="uk-text-small uk-margin-small-left"
      >
        {{ likesCount }}
      </span>
    </SVGButton>

    <SVGButton
      :icon="dislikeIcon"
      title="Dislike"
      :buttonSize="true"
      :disabled="reportView"
      class="uk-margin-small-left"
      :style="`border:none; background:none;`"
      :size="buttonSize"
      @click="onDislike"
    >
      <span
        v-if="showCounts"
        :style="{ color: reportView ? 'black' : '' }"
        class="uk-text-small uk-margin-small-left"
      >
        {{ dislikesCount }}
      </span>
    </SVGButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SVGButton from '@/components/display/button/SVGButton.vue';

// Props
interface Props {
  likeStatus?: 'like' | 'dislike' | null;
  likesCount?: number;
  dislikesCount?: number;
  showCounts?: boolean;
  publicView?: boolean;
  reportView?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  likeStatus: null,
  likesCount: 0,
  dislikesCount: 0,
  showCounts: true,
  publicView: false,
  reportView: false,
});

// Emits
const emit = defineEmits(['like', 'dislike']);

// Computed
const likeIcon = computed(() => {
  return props.likeStatus === 'like' ? 'thumbs-up-green' : 'thumbs-up';
});

const dislikeIcon = computed(() => {
  return props.likeStatus === 'dislike' ? 'thumbs-down-red' : 'thumbs-down';
});

const buttonSize = computed(() => {
  return props.publicView || props.reportView ? '1em' : '.75em';
});

// Methods
const onLike = () => emit('like');
const onDislike = () => emit('dislike');
</script>

<style scoped lang="scss">
.like-button {
  width: 1em;
}
</style>
